import type { QuestionTemplate } from '../types';

export const questionTemplates: QuestionTemplate[] = [
  {
    id: 'template-1',
    text: 'Como você deve proceder ao receber um pedido no aplicativo?',
    type: 'single',
    category: 'Procedimentos',
    difficulty: 'easy',
    options: [
      {
        id: 'opt-1',
        text: 'Verificar todos os detalhes antes de aceitar',
        isCorrect: true,
        feedback: 'Correto! É importante verificar o endereço e valor antes de aceitar o pedido.'
      },
      {
        id: 'opt-2',
        text: 'Aceitar imediatamente para não perder tempo',
        isCorrect: false,
        feedback: 'Incorreto. Aceitar sem verificar pode causar problemas depois.'
      },
      {
        id: 'opt-3',
        text: 'Esperar alguns minutos antes de aceitar',
        isCorrect: false,
        feedback: 'Incorreto. Demorar para aceitar pode fazer você perder o pedido.'
      }
    ]
  },
  {
    id: 'template-2',
    text: 'Quais documentos são necessários para realizar entregas?',
    type: 'multiple',
    category: 'Documentação',
    difficulty: 'medium',
    options: [
      {
        id: 'opt-1',
        text: 'CNH válida',
        isCorrect: true,
        feedback: 'Correto! A CNH é um documento obrigatório.'
      },
      {
        id: 'opt-2',
        text: 'Documento do veículo',
        isCorrect: true,
        feedback: 'Correto! O documento do veículo é necessário.'
      },
      {
        id: 'opt-3',
        text: 'Comprovante de endereço',
        isCorrect: true,
        feedback: 'Correto! O comprovante é necessário para cadastro.'
      }
    ]
  },
  {
    id: 'template-3',
    text: 'Como você deve agir em caso de problemas durante a entrega?',
    type: 'single',
    category: 'Resolução de Problemas',
    difficulty: 'medium',
    options: [
      {
        id: 'opt-1',
        text: 'Contatar o suporte imediatamente',
        isCorrect: true,
        feedback: 'Correto! O suporte pode te ajudar a resolver a situação.'
      },
      {
        id: 'opt-2',
        text: 'Tentar resolver por conta própria',
        isCorrect: false,
        feedback: 'Incorreto. É importante seguir os procedimentos padrão.'
      },
      {
        id: 'opt-3',
        text: 'Abandonar a entrega',
        isCorrect: false,
        feedback: 'Incorreto. Nunca abandone uma entrega sem comunicar.'
      },
      {
        id: 'opt-4',
        text: 'Ignorar o problema',
        isCorrect: false,
        feedback: 'Incorreto. Problemas devem ser tratados adequadamente.'
      }
    ]
  }
];